import { useMutation } from '@apollo/client'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../LoadingOverlay/LoadingOverlayContext'
import { SEPOMEX_MUTATION } from '../../../graphql/Global/sepomex'
import Box from '../../Global/Box'
import InputController from '../../Global/InputController'
import { GET_ALL_CITIZENS_MUTATIONS } from '../../../graphql/Catalog/Processes/Citizens/processesCitizens'
import { add, get } from 'lodash'
import GoogleMapComponentV2 from '../../Global/GoogleMapComponentV2'

const FormCitizen = ({ refWizard, data, setData, setIsValidSteps }) => {
  const { showLoading, hideLoading } = useLoading()

  const [zipCode, setZipCode] = useState('')
  const [collapseAddress, setCollapseAddress] = useState(false)

  //OPTIONS
  const [colonyOptions, setColonyOptions] = useState([])
  const [optionsCitizen, setOptionsCitizen] = useState([])
  const [valueSearch, setValueSearch] = useState('')
  const [citizenData, setCitizenData] = useState(null)

  //STATES FOR GOOGLE MAPS
  const [coordinates, setCoordinates] = useState(null)
  const [isEditingMarkerPosition, setIsEditingMarkerPosition] = useState(false)
  const [address, setAddress] = useState(null)

  const validationSchema = Yup.object().shape({
    citizen_id: Yup.string(),
    name: Yup.string().required('El nombre es requerido'),
    last_name: Yup.string().required('El apellido es requerido'),
    email: Yup.string().email('El email es inválido'),
    phone: Yup.string()
      .test('phone', 'El teléfono es inválido', (value) => {
        if (!value) return true
        const regex = /^\d{10}$/
        return regex.test(value)
      })
      .nullable(),
    // phone: Yup.string()
    //   .matches(/^\d+$/, 'El teléfono debe contener solo números')
    //   .min(10, 'El teléfono debe tener al menos 10 caracteres')
    //   .max(10, 'El teléfono no puede tener más de 10 caracteres')
    //   .trim(),
    //   // .required('El teléfono es requerido'),
    address_full: Yup.string().nullable(),
    coordinates: Yup.string().nullable(),
    address: Yup.string().nullable(),
  })

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    methods,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  // const [sepomex] = useMutation(SEPOMEX_MUTATION)
  const [searchCitizen] = useMutation(GET_ALL_CITIZENS_MUTATIONS)

  useEffect(() => {
    try {
      if (valueSearch !== '' && !valueSearch) return

      const fetchCitizens = async () => {
        try {
          const { data } = await searchCitizen({
            variables: {
              searchQuery: valueSearch,
              limit: 100,
              offset: 0,
            },
            fetchPolicy: 'no-cache',
          })

          const infoCitizens = data.getAllProcessesCitizensMutation.rows.map(
            (citizen) => {
              return {
                label: `${citizen.name} ${citizen.last_name}`,
                value: citizen.id,
                email: citizen.email,
                citizenData: citizen,
              }
            }
          )

          setOptionsCitizen(infoCitizens)
          setValueSearch(null)
        } catch (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
      }

      fetchCitizens()
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [valueSearch])

  useEffect(() => {
    if (coordinates)
      setValue('coordinates', `${coordinates.lat},${coordinates.lng}`)
    else setValue('coordinates', '')

    if (address) {
      const addressComplete = address.formatted_address
      setValue('address_full', addressComplete)
    } else setValue('address_full', '')
  }, [coordinates, address])

  // useEffect(() => {
  //   try {
  //     if (!zipCode) return

  //     const fetchSepomex = async () => {
  //       try {
  //         const { data } = await sepomex({
  //           variables: {
  //             zipCode: +zipCode,
  //           },
  //         })

  //         const infoSepomex = data.getFullAddressByZipcode

  //         const getColonies = infoSepomex.colonies.map((colony) => {
  //           return {
  //             label: colony.colony_name,
  //             value: colony.colony_name,
  //           }
  //         })

  //         if (infoSepomex.city_name !== 'Sin Ciudad')
  //           setValue('city', infoSepomex.city_name)
  //         setValue('state', infoSepomex.state_name)
  //         setValue('country', infoSepomex.country_name)
  //         setColonyOptions(getColonies)
  //       } catch (error) {
  //         return toastSweetAlert({
  //           mode: 'error',
  //           message: error.message,
  //         })
  //       }
  //     }

  //     fetchSepomex()
  //   } catch (error) {
  //     return toastSweetAlert({
  //       mode: 'error',
  //       message: error.message,
  //     })
  //   }
  // }, [zipCode])

  // useEffect(() => {
  //   if (!collapseAddress) {
  //     setValue('zip_code', '')
  //     setValue('address', '')
  //     setValue('city', '')
  //     setValue('state', '')
  //     setValue('country', '')
  //     setValue('colony', '')

  //     document.getElementById('collapseAddress').classList.remove('show')
  //   }

  //   if (collapseAddress) {
  //     document.getElementById('collapseAddress').classList.add('show')
  //   }
  // }, [collapseAddress])

  useEffect(() => {
    if (data && data.stepCitizen) {
      reset(data.stepCitizen)
      setIsEditingMarkerPosition(data.stepCitizen.coordinates)
    }
  }, [data])

  useEffect(() => {
    if (citizenData) {
      setValue('citizen_id', citizenData.id)
      reset({
        citizen_id: citizenData.id,
        name: citizenData.name,
        last_name: citizenData.last_name,
        email: citizenData.email,
        phone: citizenData.phone,
        address_full: citizenData.address_full,
        coordinates: citizenData.coordinates,
        address: citizenData.address || '',
      })

      setIsEditingMarkerPosition(citizenData.coordinates)
    }
  }, [citizenData])

  const onSubmit = async (data) => {
    showLoading()
    try {
      setData((prev) => ({
        ...prev,
        stepCitizen: data,
      }))
      setIsValidSteps((prev) => ({
        ...prev,
        stepCitizen: true,
      }))

      refWizard.current.nextTab()
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      // handleCloseModal()
      // document.getElementById(`spanModal${refModal}`).click()
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title="Datos del solicitante"
            errors={errors}
            btnSubmit
            btnSubmitText="Siguiente"
            // btnSubmit
            // btnSubmitText={requestId ? 'Actualizar' : 'Crear'}
            content={
              <>
                <div className="row">
                  {/* <div className="col-6">
                    <InputController
                      control={control}
                      name="client_uid"
                      label="Cliente"
                      placeHolderChoosen="Cliente"
                      inputType="choosen"
                      options={clientOptions}
                      menuPosition="fixed"
                      onInputChange={(val) => setInputValue(val)}
                      changeAction={(e) => handleClientSelected(e)}
                    />
                  </div> */}
                  <div className="col-lg-6">
                    <InputController
                      name="citizenSearch"
                      label="Buscar ciudadano"
                      control={control}
                      inputType="choosen"
                      options={optionsCitizen}
                      placeholderTxt="Busca un ciudadano"
                      onInputChange={(value) => setValueSearch(value)}
                      changeAction={(e) => {
                        if (!e) return
                        setCitizenData(e.citizenData)
                      }}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="hide">
                    <InputController name="citizen_id" control={control} />
                  </div>
                  <div className="col-lg-6">
                    <InputController
                      name="name"
                      label="Nombre de solicitante"
                      control={control}
                    />
                  </div>
                  <div className="col-lg-6">
                    <InputController
                      name="last_name"
                      label="Apellido de solicitante"
                      control={control}
                    />
                  </div>
                  <div className="col-lg-6">
                    <InputController
                      name="email"
                      label="Email de solicitante"
                      control={control}
                    />
                  </div>
                  <div className="col-lg-6">
                    <InputController
                      name="phone"
                      label="Teléfono de solicitante"
                      control={control}
                      maxLength={10}
                    />
                  </div>
                  {data && data.stepProcess.process_key === 'processes_geo' && (
                    <>
                      <div className="col-lg-6">
                        <InputController
                          name="address_full"
                          label="Dirección de solicitante"
                          control={control}
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="coordinates"
                          label="Coordenadas de solicitante"
                          control={control}
                          disabled
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="address"
                          label="Dirección de solicitante Manual"
                          control={control}
                          placeholderTxt="Dirección manual"
                        />
                      </div>
                      {/* <GoogleMapComponent
                        address={address?.formatted_address || address}
                        setAddress={setAddress}
                        setCoordinates={setCoordinates}
                        isEditingMarkerPosition={isEditingMarkerPosition}
                      /> */}
                      <GoogleMapComponentV2
                        setCoordinates={setCoordinates}
                        address={address}
                        setAddress={setAddress}
                        isEditingMarkerPosition={isEditingMarkerPosition}
                        showInputAutocomplete={true}
                        // colonySelected={colonySelected}
                        // setColonySelected={setColonySelected}
                      />
                    </>
                  )}
                  {/* <span
                    data-toggle="collapse"
                    data-target="#collapseAddress"
                    aria-expanded="false"
                    aria-controls="collapseAddress"
                    className="btn btn-sm btn-accept"
                    onClick={() => setCollapseAddress(!collapseAddress)}
                    style={{
                      cursor: 'pointer',
                      padding: '10px',
                      margin: '10px',
                    }}
                  >
                    Agregar direccion +
                  </span>
                  <div
                    className={`col-12 ${collapseAddress ? 'card' : ''}`}
                    style={{
                      padding: '10px',
                    }}
                  >
                    <div
                      className={`collapse row col-12 ${
                        setCollapseAddress ? 'show' : ''
                      }`}
                      id="collapseAddress"
                    >
                      <div className="col-lg-6">
                        <InputController
                          name="zip_code"
                          label="Código postal de solicitante"
                          control={control}
                          changeAction={(e) => setZipCode(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="address"
                          label="Dirección de solicitante"
                          control={control}
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="colony"
                          label="Colonia de solicitante"
                          control={control}
                          inputType="choosen"
                          options={colonyOptions}
                          placeholderTxt="Selecciona una colonia"
                          menuPosition="fixed"
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="city"
                          label="Ciudad de solicitante"
                          control={control}
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="state"
                          label="Estado de solicitante"
                          control={control}
                          disabled
                        />
                      </div>
                      <div className="col-lg-6">
                        <InputController
                          name="country"
                          label="País de solicitante"
                          control={control}
                          disabled
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default FormCitizen
